import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { UserModel } from "../models/user.model";
import { LocalStorageService } from "./local-storage.service";

@Injectable({ providedIn: "root" })
export class AppAuthService {
  url = environment.urlApi;

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly storageService: LocalStorageService
  ) { }

  authenticated() {
    return this.token() !== null;
  }

  async login(model: any): Promise<void> {
    await this.http
      .post(`${this.url}/auths/admin`, model)
      .subscribe(async (result: any) => {
        if (!result || !result.token) { return; }
        this.storageService.set('token', result.token);
        this.storageService.set('usuario', result.usuario);
        await this.router.navigate(["/home"]);
      });
  }

  async signin() {
    await this.router.navigate(["/auth/login"]);
  }

  async signout() {
    this.storageService.clear();
    localStorage.clear();
    sessionStorage.clear();
    await this.signin();
  }

  token() {
    return this.storageService.get('token');
  }

  usuario(): UserModel {
    return this.storageService.get('usuario');
  }
}
